export default "__VITE_ASSET__DVPMAMOU__"